<div *ngIf="fetchData && activeDocumentDetails" style="height: 100%;margin-top: 2px;">
    <div *ngIf="versionWarning" class="alert alert-warning" role="alert">{{versionWarning}}</div>
    <div class="row">
        <div class="col-4" style="overflow-y: scroll;position: relative;height:calc(100vh - 50px); width:100%;">
            <div *ngIf="searchResultsList && showSearchDocList">
                <mat-accordion displayMode="flat">
                    <mat-expansion-panel class="documentList" open>
                        <mat-expansion-panel-header [class.selected-header]="selectedHeader === 2"
                            (click)="selectedHeader = 1" collapsedHeight="30px" expandedHeight="30px"
                            style="background-color: rgb(110, 192, 27); ">
                            <mat-panel-title style="color: white;">List of Documents</mat-panel-title>
                            <mat-divider></mat-divider>
                        </mat-expansion-panel-header>
                        <div>
                            <mat-list-item>
                                <table mat-table [dataSource]="searchResultsList" matSort aria-describedby="docs-table">

                                    <ng-container matColumnDef="categoryName">
                                        <th id="name" mat-header-cell *matHeaderCellDef mat-sort-header> Category Name
                                        </th>
                                        <td mat-cell *matCellDef="let element"> {{element.categoryName}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="documentName">
                                        <th id="documentName" mat-header-cell *matHeaderCellDef mat-sort-header>
                                            Document Title </th>
                                        <td mat-cell *matCellDef="let element"> {{element.documentName}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="versionNum">
                                        <th id="versionNum" mat-header-cell *matHeaderCellDef mat-sort-header> Version
                                            Number </th>
                                        <td mat-cell *matCellDef="let element"> {{element.VersionNumber}} </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="searchResultsCols"></tr>
                                    <tr mat-row *matRowDef="let row; columns: searchResultsCols;"
                                        (click)="getDocDetails($event, row)" class="element-row"
                                        [class.selected-row]="selectedRow === row"
                                        (click)="selectedRow = selectedRow === row ? null : row">
                                    </tr>
                                </table>
                                <mat-paginator style="padding: 0;margin: 0;" [pageSizeOptions]="[5,10, 20, 50]"
                                    [pageSize]="5" showFirstLastButtons>
                                </mat-paginator>
                            </mat-list-item>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
            <div *ngIf="!uploadMessage && !isUpdateCategory && !isUpdateDocumentTitle">
                <div class="row mt-1 mb-1">
                    <div class="col-12 btn-group" role="group" aria-label="First group">
                        <button mat-raised-button class="btn btn-small col" (click)="showDocList()">
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                        <button mat-raised-button class="btn btn-small col"

                            *ngIf="aclGroup.browse.documentActions.updateMetadata"

                            [ngStyle]="{'background-color': openMetaData ? 'green' : '' }" title="Update Metadata"
                            (click)="openUpdateMetaData()"
                            [disabled]="documentDetails.locked && this.isLockUser">
                            <mat-icon>update</mat-icon>
                        </button>
                        <button mat-raised-button class="btn btn-small col"

                            *ngIf="aclGroup.browse.documentActions.uploadVersion"

                            [ngStyle]="{'background-color': openUpload ? 'green' : '' }" title="Upload Version"
                            (click)="openUploadDocument()"
                            [disabled]="(!documentDetails.locked)||(documentDetails.locked && this.isLockUser)">
                            <mat-icon>cloud_upload</mat-icon>
                        </button>

                        <!-- <button mat-raised-button class="btn btn-small col"
                            [ngStyle]="{'background-color': openOnlyRedact ? 'green' : '' }" title="Redaction Information"

                            title="Redact Document" 

                            (click)="openRedact()"
                            [disabled]="documentDetails.locked || !isUpdateGroup || !documentDetails.active" *ngIf="showRedaction">

                            <mat-icon>description</mat-icon>

                        </button> -->


                        <button mat-raised-button class="btn btn-small col"

                            *ngIf="aclGroup.browse.documentActions.lock"

                            (click)="lockUnlockDocument(documentDetails.locked)"
                            [disabled]="isLockUser || !documentDetails.active">
                            <mat-icon title="Unlock Document" *ngIf=documentDetails.locked>lock</mat-icon>
                            <mat-icon title="Lock Document" *ngIf=!documentDetails.locked>lock_open
                            </mat-icon>
                        </button>
                        <button mat-raised-button class="btn btn-small col" title="Delete Document"

                            *ngIf="aclGroup.browse.documentActions.deleteDoc"

                            [disabled]="(documentDetails.locked || !documentDetails.active) || !isDeleteGroup"
                            (click)="deleteDocument()">
                            <mat-icon title="Delete Document">delete</mat-icon>
                        </button>
                        <!-- Comment Image Trust button for MCR-->

                        <!-- <button *ngIf="enableImageTrust" mat-raised-button class="btn btn-small col" title="Open ImageTrust"

                            [disabled]="documentDetails.locked" (click)="openImageTrust()">
                            <mat-icon>open_in_new</mat-icon>

                        </button> -->

                        <button mat-raised-button class="btn btn-small col"

                            *ngIf="aclGroup.browse.documentActions.history"

                            [ngStyle]="{'background-color': openHistory ? 'green' : 'rgb(110, 192, 27)' }"
                            title="History" (click)="openHistoryTab()">
                            <mat-icon>history_toggle_off</mat-icon>
                        </button>
                        <button mat-raised-button class="btn btn-small col"

                            *ngIf="aclGroup.browse.documentActions.comment"

                            [ngStyle]="{'background-color': openCommentTab ? 'green' : 'rgb(110, 192, 27)' }"
                            title="Comments" (click)="openCommentSection()">
                            <mat-icon>comment</mat-icon>
                        </button>
                        <!-- <button mat-raised-button class="btn btn-small col"
                            [ngStyle]="{'background-color': openRedactDocumentTab ? 'green' : '' }" title="Redact words"
                            (click)="redactDocument()">
                            <mat-icon>line_style</mat-icon>
                        </button> -->
                        <button mat-raised-button class="btn btn-small col"

                            *ngIf="aclGroup.browse.documentActions.attachment"

                            [ngStyle]="{'background-color': openShareLinkTab ? 'green' : '' }" title="Generate document link that can be shared"
                            (click)="shareDocumentLinkHandler()">
                            <mat-icon>attachment</mat-icon>
                        </button>
                        <button mat-raised-button class="btn btn-small col" title="Refresh"

                            *ngIf="aclGroup.browse.documentActions.refresh"

                            (click)="refreshDocumentDetails()">
                            <mat-icon>refresh</mat-icon>
                        </button>

                    </div>
                </div>
            </div>
            <div *ngIf="!isUpdateCategory && !isUpdateDocumentTitle">
                <div class="card">
                    <div class="card-body">
                        <div class="container">
                            <div class="properties-column row">

                                <span class="col-4" style="font-weight: 500;">Category: </span>
                                <span class="properties-value col-6">{{documentDetails.categoryName}}</span>
                                <span class="col-2" *ngIf="!documentDetails.locked && documentDetails.active">
                                    <mat-icon style="transform: scale(.75); cursor: pointer;"
                                        (click)="updateCategory()">
                                        edit</mat-icon>
                                </span>
                                <div *ngIf="isUpdateCategory">
                                    <app-dialog-update-category [documentID]="documentID"
                                        [documentType]="documentDetails.metadata.system.type">
                                    </app-dialog-update-category>
                                </div>
                            </div>
                            <div class="properties-column row">
                                <span class="col-4" style="font-weight: 500;">Title: </span>
                                <span class="properties-value col-6">{{activeDocumentDetails.documentName}}</span>
                                <span class="col-2" *ngIf="!documentDetails.locked && documentDetails.active">
                                    <mat-icon style="transform: scale(.75); cursor: pointer;"
                                        (click)="updateDocumentTitle()">
                                        edit</mat-icon>
                                </span>
                            </div>
                            <div class="properties-column row">
                                <span class="col-4" style="font-weight: 500;">Document Id: </span>
                                <span class="properties-value col-8">{{documentDetails.documentId}}</span>
                            </div>
                            <div class="properties-column row">
                                <span class="col-4" style="font-weight: 500;">Version Number: </span>
                                <span class="properties-value col-8">{{documentDetails.VersionNumber}}</span>
                            </div>
                            <div *ngIf=documentDetails.locked class="properties-column row">
                                <span class="col-4" style="font-weight: 500;">Locked By: </span>
                                <span class="properties-value col-8">{{documentDetails.locked_by}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="!openMetaData && !openUpload && !openHistory && !openCommentTab && !openRedactDocumentTab && !openOnlyRedact && !openShareLinkTab">

                    <mat-accordion displayMode="flat">

                        <mat-expansion-panel *ngIf="showRedaction && isDocumentRedactable" [expanded]="true" style="height: auto;">
                            <mat-expansion-panel-header [class.selected-header]="selectedHeader === 2"
                                (click)="selectedHeader = 2" collapsedHeight="38px" expandedHeight="38px">
                                <mat-panel-title>Redaction</mat-panel-title>
                                <mat-divider></mat-divider>
                            </mat-expansion-panel-header>
                            <div class="xAxis-scroll-auto ml-3">
                                <mat-list-item>
                                    <div class="properties-column" matLine>
                                        <span style="font-weight: 500">Status</span>
                                        <span
                                            class="properties-value">{{redactionStatus ? redactionStatus['Redaction Status']:'Not Started'}}
                                        </span>
                                    </div>

                                    <div *ngIf="!doesDocumentNameContainRedacted" class="properties-column" matLine>
                                        <span style="font-weight: 500">{{documentInReview ? 'Review Virtual Folder':'Redaction Category'}}</span>
                                        <span
                                            class="properties-value">{{redactionStatusCategory}} 
                                            <!-- redactionStatus  && redactionStatus['Redaction Status'] === "Completed" ? redactionStatusCategory : 'N/A'}}  -->
                                        </span>
                                    </div>

                                    <!-- <div *ngIf="!doesDocumentNameContainRedacted" class="properties-column" matLine>
                                        <span style="font-weight: 500">Start Time</span>
                                        <span
                                            class="properties-value">{{redactionStatus['Job Start Time']  | date:'medium' }}
                                        </span>
                                    </div>

                                    <div *ngIf="!doesDocumentNameContainRedacted"  class="properties-column" matLine>
                                        <span style="font-weight: 500">End Time</span>
                                        <span
                                            class="properties-value">{{redactionStatus['Job End Time']  | date:'medium' }}
                                        </span>
                                    </div> -->
                                </mat-list-item>
                            </div>
                        </mat-expansion-panel>


                        <mat-expansion-panel open>
                            <mat-expansion-panel-header [class.selected-header]="selectedHeader === 1"
                                (click)="selectedHeader = 1" collapsedHeight="38px" expandedHeight="38px">
                                <mat-panel-title>File Properties</mat-panel-title>
                                <mat-divider></mat-divider>
                            </mat-expansion-panel-header>
                            <div class="xAxis-scroll-auto">
                                <mat-list-item>
                                    <div class="container">
                                        <div class="row" matLine>
                                            <div class="col-4" style="font-weight: 500">File Name</div>
                                            <div class="col-8 properties-value">
                                                {{documentDetails.documentVersionFileName}}</div>
                                        </div>
                                    </div>
                                    <div class="container">
                                        <div class="row" matLine>
                                            <div class="col-4" style="font-weight: 500">File Type</div>
                                            <div class="col-8 properties-value">
                                                {{documentDetails.metadata.system.type}}</div>
                                        </div>
                                    </div>
                                    <div class="container">
                                        <div class="row" matLine>
                                            <div class="col-4" style="font-weight: 500">File Size</div>
                                            <div class="col-8 properties-value">
                                                {{documentDetails.metadata.system.size | filesize}}</div>
                                        </div>
                                    </div>
                                    <div class="container" *ngIf="documentDetails.metadata.properties['Public Search'] == true">
                                        <div class="row" matLine>
                                            <div class="col-4" style="font-weight: 500">Static File Link</div>
                                            <div class="col-8 properties-value">
                                                <a [href]="publicLink" target="_blank" rel="noopener noreferrer">{{publicLink}}</a></div>
                                        </div>
                                    </div>
                                </mat-list-item>
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel style="height: auto;">
                            <mat-expansion-panel-header [class.selected-header]="selectedHeader === 2"
                                (click)="selectedHeader = 2" collapsedHeight="38px" expandedHeight="38px">
                                <mat-panel-title>File Metadata</mat-panel-title>
                                <mat-divider></mat-divider>
                            </mat-expansion-panel-header>
                            <div class="xAxis-scroll-auto ">
                                <div *ngIf="propertyCols.length < 1" style="text-align: center;">No metadata defined for
                                    this document</div>
                                <mat-list-item *ngFor="let column of activeDocumentDetails.categoryMetaData.properties">
                                    <div class="properties-column row" matLine>
                                        <span style="font-weight: 500" class="col">{{column.name}}</span>
                                        <span *ngIf="!(values[column.name]=='[object Object]')"
                                            class="properties-value col">{{values[column.name]}}
                                        </span>
                                        <!-- && column.name!='Enable Redaction' (for above) <span *ngIf="(column.name=='Enable Redaction')"
                                            class="properties-value">
                                            <mat-slide-toggle name="{{column.name}}" [(ngModel)]="isDocRedactionEnabled">
                                            </mat-slide-toggle>
                                        </span>    && column.name!='Enable Redaction' (for below ngif) -->

                                        <span *ngIf="values[column.name]=='[object Object]'"
                                            class="properties-value col">{{values[column.name] | json}}
                                        </span>

                                    </div>
                                </mat-list-item>
                                <!-- <div *ngIf="shouldDisplayRedactButton && values['Enable Redaction'] != isDocRedactionEnabled" style="display: flex; justify-content: center; align-items: center; width: 100%;">
                                    <button class="closeButton float-right m-2" mat-raised-button (click)="cancelRedactToggle()">Cancel</button>
                                    <button class="actionButton float-right m-2" mat-raised-button (click)="updateRedactDoc()" type="submit"
                                       >Save</button>
                                </div> -->

                            </div>
                        </mat-expansion-panel>                        
                        <mat-expansion-panel class="documentList">
                            <mat-expansion-panel-header [class.selected-header]="selectedHeader === 3"
                                (click)="selectedHeader = 3" collapsedHeight="38px" expandedHeight="38px">
                                <mat-panel-title>Version Info</mat-panel-title>
                                <mat-divider></mat-divider>
                            </mat-expansion-panel-header>
                            <div class="xAxis-scroll-auto ">
                                <mat-list-item>
                                    <table mat-table matSort [dataSource]="documentVersions" matSortActive="name"
                                        matSortDirection="asc" aria-describedby="versions-table">
                                        <ng-container matColumnDef="versionNumber">
                                            <th id="versionNum" mat-header-cell *matHeaderCellDef mat-sort-header>
                                                Number </th>
                                            <td mat-cell *matCellDef="let version"> {{version.VersionNumber}} </td>
                                        </ng-container>
                                        <ng-container matColumnDef="fileName">
                                            <th id="fileName" mat-header-cell *matHeaderCellDef mat-sort-header> Name
                                            </th>
                                            <td mat-cell *matCellDef="let version">
                                                <span *ngIf="version.active" title="View Version" class="version-name"
                                                    (click)="showVersionDocument($event, version)">
                                                    <strong>{{version.documentVersionFileName}}</strong>
                                                </span>
                                                <span *ngIf="!version.active" title="View Version" class="version-name"
                                                    (click)="showVersionDocument($event, version)">
                                                    {{version.documentVersionFileName}}
                                                </span>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="actions">
                                            <th id="action" mat-header-cell *matHeaderCellDef mat-sort-header> Actions
                                            </th>
                                            <td mat-cell *matCellDef="let version">
                                                <span *ngIf="version.active">
                                                    <mat-icon title="Active Version" style="transform: scale(0.75);"
                                                        #authMenu [matMenuTriggerFor]="menu">
                                                        info</mat-icon>
                                                    <mat-menu class="my-menu pl-2 p-1" #menu="matMenu">
                                                        <span style="font-size: 10pt;">
                                                            This is an active version. Please activate another version
                                                            to delete this version.
                                                        </span>
                                                    </mat-menu>
                                                </span>
                                                <span *ngIf="!version.active">
                                                    <mat-icon class="version-table-icons" aria-label="Activate"
                                                        title="Activate Version" (click)="activateVersion(version)">
                                                        play_arrow
                                                    </mat-icon>
                                                    <mat-icon class="version-table-icons" aria-label="Delete"
                                                        title="Delete Version" (click)="deleteVersion(version)">delete
                                                    </mat-icon>
                                                </span>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                    </table>
                                </mat-list-item>
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel *ngIf="workflowProcesses && enableWorkflow" class="documentList mb-1">
                            <mat-expansion-panel-header [class.selected-header]="selectedHeader === 2"
                                (click)="selectedHeader = 2" collapsedHeight="38px" expandedHeight="38px">
                                <mat-panel-title>Workflow History</mat-panel-title>
                                <mat-divider></mat-divider>
                            </mat-expansion-panel-header>

                            <!-- <div class="xAxis-scroll-auto ">

                                <app-workflow-history [DocID]="documentDetails.documentId" [processes]="workflowProcesses">
                                </app-workflow-history>


                            </div> -->

                        </mat-expansion-panel>

                    </mat-accordion>
                </div>



                <app-qna *ngIf="aclGroup.browse.qna" [documentId]="documentID">
                </app-qna>




                <app-apply-hold

                    *ngIf="isRecordsManager && !openMetaData && !openUpload && !openHistory && !openCommentTab && !openRedactDocumentTab && !openOnlyRedact && !openShareLinkTab"

                    [documentID]="documentID" [hold]="activeDocumentDetails.onhold"
                    [holdGroupNames]="activeDocumentDetails.holdgroupname">
                </app-apply-hold>
            </div>

            <div

                *ngIf="isUpdateCategory && !openMetaData && !isUpdateDocumentTitle && !openUpload && !openHistory && !openRedactDocumentTab && !openOnlyRedact && !openShareLinkTab">

                <app-dialog-update-category [documentID]="documentID" (isUpdateCategory)="onHideUpdateCategory($event)">
                </app-dialog-update-category>
            </div>

            <div

                *ngIf="!isUpdateCategory && !openMetaData && isUpdateDocumentTitle && !openUpload && !openHistory && !openRedactDocumentTab && !openOnlyRedact">

                <app-update-document-title [documentID]="documentID"
                    (isUpdateDocumentTitle)="onHideUpdateDocumentTitle($event)">
                </app-update-document-title>
            </div>

            <div *ngIf="openMetaData">
                <app-dialog-update [document]="activeDocumentDetails" (openMetaData)="backFromMetaData($event)"
                    (close)="closeTabs($event)" (refreshDetails)="eventSuccessHandler()">
                </app-dialog-update>
            </div>

            <div *ngIf="openUpload">
                <app-dialog-upload [documentDetails]="activeDocumentDetails" (openUpload)="backFromUpload($event)"
                    (close)="closeTabs($event)"(refreshDetails)="eventSuccessHandler()">
                </app-dialog-upload>
            </div>

            <div *ngIf="openHistory">
                <app-audit-document [documentId]="documentID" (openHistory)="backFromHistoryTab($event)">
                </app-audit-document>
            </div>

            <div *ngIf="openCommentTab">
                <app-comments-section [documentId]="documentID" [versionNumber]="documentDetails.VersionNumber"
                    (openCommentTab)="backFromCommentSection($event)">
                </app-comments-section>
            </div>

            <div *ngIf="openRedactDocumentTab">
                <app-redact-keywords [documentId]="documentID"
                    (openRedactDocumentTab)="backFromRedactDocumentTab($event)" (close)="closeTabs($event)">
                </app-redact-keywords>
            </div>


            <div *ngIf="openOnlyRedact">
                <app-manual-redaction [documentId]="documentID" [redactionStatus]="redactionStatus" [documentDetails]="documentDetails"
                (openRedactionDialog)="openRedactionDialog()" (close)="closeTabs($event)">
                </app-manual-redaction>
            </div>


            <div *ngIf="openShareLinkTab">
                <app-share-document-link [documentId]="documentID"
                (close)="closeTabs($event)">
                </app-share-document-link>
            </div>

        </div>
        <div *ngIf="!hideDocView" class="col-8 p-0" style="overflow: hidden;">
            <div style="height: calc(100vh - 50px);">
                <app-fileView [documentID]="documentID" [versionNumber]="docVersionNumber"

                    [documentType]="documentDetails.metadata.system.type" [searchText]="searchText"
                    [fileName]="documentDetails.metadata.system.fileName">

                </app-fileView>
            </div>
        </div>
    </div>
</div>
<div *ngIf="isVersionsNotAvailable">
    <div class="card mt-3">
        <div class="card-body" style="text-align: center;">
            <div role="alert">{{versionError}}</div>
            <div>
                <button style="float: right;" mat-raised-button (click)="showDocList()">Back</button>
            </div>  
        </div>
    </div>
</div>

<ng-template #redactionPopup>
    <div class="card mt-3">
        <div class="card-body" style="text-align: center;">
            <div *ngIf="isDocumentRedactable">

                <p *ngIf="isDocAlreadyRedacted; else DocTypeCheck">This document has already been sent for redaction.   </p>

                 <!--<p *ngIf="!isDocTypeCorrectForRedact; else docTypeCorrectForRedact"> Redaction is not supported for this document. Please upload a document with one of the following types: pdf, jpg, png.</p>
                <p *ngIf="isDocAlreadyRedacted"> This document is already redacted. It cannot be redacted again. </p>
                <p *ngIf="!isDocAlreadyRedacted && isDocTypeCorrectForRedact"> Do you want to Enable Redaction? </p> -->
                <ng-template #IsDocRedacted>

                    <p *ngIf="isDocAlreadyRedacted; else ShouldEnableRedact"> This document has already been sent for redaction. </p>

                </ng-template>

                <ng-template #DocTypeCheck>

                    <p *ngIf="!isDocTypeCorrectForRedact; else ShouldEnableRedact"> Redaction is not supported for this document type. Please upload a document of the following types: pdf, jpg, png. </p>

                </ng-template>
                
                <ng-template #ShouldEnableRedact>

                    <p> Are you sure you want to send the file for redaction? </p>

                </ng-template>
            </div>
            <div *ngIf="!isDocumentRedactable">

                This category does not support redaction. Please contact your administrator.

            </div>
            <div>
                <button mat-dialog-close class="closeButton float-right m-2" mat-raised-button (click)="cancelRedactToggle()">Cancel</button>
                <button *ngIf="isDocumentRedactable && isDocTypeCorrectForRedact && !isDocAlreadyRedacted" class="actionButton float-right m-2" mat-raised-button (click)="updateRedactDoc()" type="submit">Yes</button>
            </div>
        </div>
    </div>
</ng-template>
